define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var AbstractTracker = require('modules/trackers/abstract.tracker');
    var core = require('core');
    var storage = require('util/storage.util');

    module.exports = AbstractTracker.extend({
        track: function(eventName, data, viewInstance) {
            var isTrackableEvent = _.includes(this.events, eventName);
            var container;

            if (viewInstance) {
                container = viewInstance.$el ?
                    viewInstance.$el.parents('.portlet-wrapper')[0].dataset.portletId :
                    storage.session.getItem('lastGamesPortletId');
            }

            if (!isTrackableEvent) {
                return;
            }

            return core.trigger(
                eventName,
                _.extend(
                    {container: container},
                    data
                )
            );
        }
    });
});